import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CLEAR_EAI_DATA_SUCCESS,
  CREATE_EMPLOYEE_ASSET_ISSUE_SUCCESS,
  FETCH_EMPLOYEE_ASSET_ISSUE_SUCCESS,
  FETCH_EMPLOYEE_ASSETS_BY_LOCATION_SUCCESS,
  GET_EMPLOYEE_ASSET_ISSUE_SUCCESS,
  SAVE_EMPLOYEE_ASSET_ISSUE_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {
  fetchError,
  fetchFilter,
  fetchStart,
  fetchSubElementFilter,
  fetchSuccess,
  fetchSuperMasterFilter
} from "./Common";
import {getUser} from "./Auth";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_EMPLOYEE_ASSET_ISSUE_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_EMPLOYEE_ASSET_ISSUE_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_EMPLOYEE_ASSET_ISSUE_SUCCESS,
    data
  };
};
export const clearEaiData = () => {
  return {
    type: CLEAR_EAI_DATA_SUCCESS,
  }
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_EMPLOYEE_ASSET_ISSUE_SUCCESS,
    data
  };
};

export const fetchAssetsByLocationSuccess = ({data}) => {
  return {
    type: FETCH_EMPLOYEE_ASSETS_BY_LOCATION_SUCCESS,
    data,
  };
};

export const fetchAssetsByLocation = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/employee-asset-issue/asset/location?id=${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchAssetsByLocationSuccess(response.data));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {employeeAssetIssue} = store.getState();
      const {query} = employeeAssetIssue;
      const response = await axios.get(`/employee-asset-issue/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {employeeAssetIssue} = store.getState();
      const {query} = employeeAssetIssue;
      const response = await axios.get(`/employee-asset-issue?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};


export const createResource = (payload, redirect= true, module, subMaster= false, superMaster=false) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/employee-asset-issue`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
      if (!redirect) {
        if(subMaster) {
          dispatch(fetchSubElementFilter(module));
        } else {
          if (superMaster) {
            dispatch(fetchSuperMasterFilter(module));
          } else {
            dispatch(fetchFilter(module));
          }
        }
      } else {
        history.push('/employee-asset-issue');
        dispatch(getResource());
      }
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/employee-asset-issue/${id}`, payload);
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/employee-asset-issue');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/employee-asset-issue/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/employee-asset-issue/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
